import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { fontSize } from '@css/styles'
import { FontNormal } from '@css/fonts'
import { MQ, darkBlue } from '@css/constants'

export const CallNowPopupWrapper = styled('div')(css`
`)

export const Heading = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(24)};
  margin-bottom: 20px;
`)

export const Label = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  color: ${darkBlue};
  text-transform: uppercase;
`)

export const Title = styled('div')<{ variant: number }>(props => css`
  ${FontNormal(600)};
  ${fontSize(24)};
  max-width: ${props.variant === 2 ? 310 : 400}px;
  margin: 0 auto;
`)

export const Description = styled('div')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  max-width: 400px;
  margin: 20px auto 0;
`)

export const SpeakText = styled('p')(css`
  ${FontNormal(400)};
`)

export const ButtonsWrapper = styled('div')(css`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`)

export const btnStyles = css`
  margin: 0 auto 6px auto;
  width: 100%;
  max-width: 251px;
`

export const callNowBtnStyles = css`
  ${btnStyles};
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    margin-right: 5px;
    height: 24px;
    width: 24px;
    position: relative;
    top: 1px;
  }
`
